import React from "react";
import { homepageApi, useHomepageResource } from "../hooks/useHomepageResource";
import styles from "./Hero.module.css";

type RecentUsage = { period: "week" | "month"; uses: number } | null;

// The API withholds quiet periods as `period: null, uses: null`; anything else malformed is an error.
const validateRecentUsage = (input: unknown): RecentUsage => {
  const { period, uses } = (input ?? {}) as { period?: unknown; uses?: unknown };
  if (period === null && uses === null) return null;
  if ((period !== "week" && period !== "month") || typeof uses !== "number" || !Number.isInteger(uses) || uses < 0) throw new Error("Invalid recent usage");
  return { period, uses };
};

export default function RecentUsageBadge() {
  const usage = useHomepageResource(`${homepageApi}/api/stats/recent-usage`, validateRecentUsage);
  // Reserve the badge's space while loading so the headline does not jump when it appears.
  if (usage.status === "loading") return <p className={`${styles.liveBadge} ${styles.liveBadgePending}`} aria-hidden="true"><span className={styles.liveDot} /><span>Used last week</span></p>;
  if (usage.status === "error" || usage.data === null) return null;
  const { period, uses } = usage.data;
  return <p className={styles.liveBadge}><span className={styles.liveDot} aria-hidden="true" /><span>Used <b>{uses.toLocaleString("en-US")}</b> {uses === 1 ? "time" : "times"} last {period}</span></p>;
}
